export default {
  maintenanceManage: {
    search: {
      partnersType: '合作伙伴类型',
      partnersTypePlaceholder: '请选择合作伙伴类型',
      partnersTypeOne: '全部',
      partnersTypeTwo: '供应商',
      partnersTypeThree: '客户',
      partnersTypeFour: '供应商兼客户',
      businessDepartment: '事业部门',
      businessDepartmentPlaceholder: '请选择事业部门',
      businessDepartmentTypeTwo: '聚酯部',
      businessDepartmentTypeThree: '橡胶部',
      businessDepartmentTypeFour: '粮化部',
      validityStart: '有效期从',
      validityEnd: '有效期到',
      partnersName: '合作伙伴名称',
      partnersNamePlaceholder: '请选择合作伙伴名称',
      creditRating: '信用级别',
      creditRatingPlaceholder: '请选择信用级别',
      isParentCompany: '只显示母公司额度',
      isParentCompanyOne: '否',
      isParentCompanyTwo: '是',
      creditAccounts: '信用账户号',
      creditAccountsPlaceholder: '请输入信用账户号',
    },
    table: {
      divisionCode: '事业部编码',
      divisionName: '事业部名称',
      partnersCode: '合作伙伴编码',
      registeredCapital: '注册资本',
      creditAccounts: '信用账户号',
      creditAccountsPlaceholder: '信用账户号描述',
      unilateralTradeStart: '单边交易上限（低）',
      unilateralTradeEnd: '单边交易上限（高）',
      unit: '单位',
      creationDate: '创建日期',
      founder: '创建人',
      mark: '备注',
      availableQuantity: '可用交易量额度',
      uninboundQuantity: '已签合同未入库',
      undeliveryQuantity: '已签合同未发货',
      partnersType: '合作伙伴类型',
      partnersName: '合作伙伴名称',
      creditRating: '信用级别',
      setUpDate: '成立日期',
      validityStart: '有效期从',
      validityEnd: '有效期到',
      availableTrading: '可用交易量额度',
      noPutStorage: '已签合同未入库',
      unshipped: '已签合同未发货',
      supplierOrBuyer: '供方/需方',
      externalContract: '外部合同号',
      internalContract: '内部合同号',
      contractType: '合同类型',
      contractDate: '合同签订日期',
      paymentMethod: '收付款方式',
      materialCode: '物料编码',
      materialDesc: '物料描述',
      number: '数量',
      price: '单价',
      amount: '金额',
      department: '部门',
      goodsName: '品名',
      factory: '生产厂',
      currency: '币别',
      TradeType: '贸易类型',
      shipmentDate: '装船日',
      portDate: '到港日',
      MarineNo: '海运提单号',
    },
    button: {
      noSelectData: '请至少选择一条数据进行操作',
    },
    router: {
      addTransaction: '交易量额度新增',
      editTransaction: '交易量额度修改',
      maintenanceManage: '交易量额度管理',
      analysisReport: '交易量额度分析报表',
    },
  },
};
